import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./components/MainLayout";
import PersonalData from "./pages/PersonalData";
import Confirmation from "./pages/Confirmation";
import DocumentUpload from "./pages/DocumentUpload";
import Selfie from "./pages/Selfie";
import NotFound from "./pages/NotFound";
import OtherDocumentsUpload from "./pages/OtherDocumentsUpload";
import DigitalDocumentUpload from "./pages/DigitalDocumentUpload";
import ContractSuccess from "./pages/ContractSuccess";
import ConsignadoPersonalData from "./pages/Consignado/ConsignadoPersonalData.tsx";
import ConsigandoConfirmation from "./pages/Consignado/ConsigandoConfirmation.tsx";
import ConsignadoSelfie from "./pages/Consignado/ConsignadoSelfie.tsx";
import ConsignadoContractSuccess from "./pages/Consignado/ConsignadoContractSuccess.tsx";
import ConsignadoGeolocation from "./pages/Consignado/ConsignadoGeolocation.tsx";
import AuthCorbanConfirmation from "./pages/AuthCorban/AuthCorbanConfirmation.tsx";
import UserAuthenticationPersonalData from "./pages/AuthCorban/UserAuthenticationPersonalData.tsx";
import PlatGeolocation from "./pages/AuthCorban/PlatGeolocation.tsx";
import Login from "./pages/Login.tsx";

export default function GranaTech() {
  return (
    <Routes>
      <Route path="/:shorthash" element={<MainLayout />}>
        <Route index element={<Login />} />
        <Route path="dados-pessoais" element={<PersonalData />} />
        <Route path="consignado/geolocalizacao" element={<ConsignadoGeolocation />} />
        <Route path="consignado/dados-pessoais" element={<ConsignadoPersonalData />} />
        <Route path="confirmacao" element={<Confirmation />} />
        <Route path="consignado/confirmacao" element={<ConsigandoConfirmation />} />
        <Route path="upload-documentos" element={<DocumentUpload />} />
        <Route path="documento-digital" element={<DigitalDocumentUpload />} />
        <Route path="outros-documentos" element={<OtherDocumentsUpload />} />
        <Route path="selfie" element={<Selfie />} />
        <Route path="consignado-selfie" element={<ConsignadoSelfie />} />
        
      </Route>

      <Route path="/:shorthash/contrato" element={<ContractSuccess />} />
      <Route path="/:shorthash/consignado/contrato" element={<ConsignadoContractSuccess />} />
      <Route
        path="/:shorthash/plat/geolocalizacao"
        element={<PlatGeolocation />}
      />
      <Route
        path="/:shorthash/plat/dados-pessoais"
        element={<UserAuthenticationPersonalData />}
      />
      <Route
        path="/plat/confirmacao"
        element={<AuthCorbanConfirmation />}
      />

      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
